import { GlobalConfig } from 'ngx-toastr';

export default {
  positionClass: 'toast-bottom-center',
  preventDuplicates: true,
  extendedTimeOut: 2500,
  enableHtml: true
} as Partial<GlobalConfig>;
